<template>
  <v-app-bar dense fixed
    color="bg_1"
    :dark="this.$vuetify.theme.dark"
    app
    @focusout="closeSideBar()"
    elevation="2"
  >
    <router-link class="navbar-brand"
                 :class="{'text-black' : !this.$vuetify.theme.dark,
                          'text-white' : this.$vuetify.theme.dark }"
                 to="/">
      <v-app-bar-title>
        <img width="18" :src="mainLogoImg" />
        {{ $t('english_door') }}
      </v-app-bar-title>
    </router-link>
    <v-spacer></v-spacer>
 
    <!-- Anchor links for main page sections -->
    <v-menu  offset-y v-if="isMainPage && !isMobile" 
     transition="slide-y-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small text class="nav-btn" v-bind="attrs" v-on="on">
          {{ $t('services') }} <v-icon small>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item @click="scrollToSection('hero')">
          <v-list-item-title>{{ $t('home') }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="scrollToSection('services')">
          <v-list-item-title>{{ $t('how_it_works') }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="scrollToSection('features')">
          <v-list-item-title>{{ $t('features') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-btn v-show="!isMobile" small text class="nav-btn" to="/student/register">{{ $t('register') }}</v-btn>
    <v-btn v-show="!isMobile" small text class="nav-btn" to="/main/class-info">{{ $t('how_it_works') }}</v-btn>


    <v-btn v-show="!isMobile" small text class="nav-btn" to="/main/teacher">{{ $t('teacher_list') }}</v-btn>
    <v-btn v-show="!isMobile" small text class="nav-btn" to="/main/content">{{ $t('book_sample') }}</v-btn>
    <v-btn v-show="!isMobile" small text class="nav-btn" to="/main/guide/call">{{ $t('app_installation') }}</v-btn> 

    <v-btn @click="openSideBar" text class="ml-2">
      <v-app-bar-nav-icon></v-app-bar-nav-icon>
    </v-btn>

  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NavBar',
  computed: {
    ...mapGetters(['app','user','isMobile']),
    mainLogoImg(){
      return `${this.app.cdnUrl}/website/logo/en9door` + (this.$vuetify.theme.dark ? '_dark.png' : '.png' );
    },
    classObj() {
      return {
        collapse: !this.app.sidebar.opened,
        show: this.app.sidebar.opened
      }
    },
    isMainPage() {
      return this.$route.path === '/' || this.$route.path === '/main';
    }
  },
  created() { },
  mounted() { },
  methods: {
    async logout() {
      await this.$store.dispatch('logout')
      this.$router.replace('/')
      this.$router.go();
    },
    openSideBar() {
      this.$store.dispatch('openSideBar')
    },
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    closeSideBar() {
      this.$store.dispatch('closeSideBar')
    },
    scrollToSection(sectionId) {
      if (this.isMainPage) {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        this.$router.push('/').then(() => {
          setTimeout(() => {
            const element = document.getElementById(sectionId);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }, 500);
        });
      }
    }
  }
}
</script>

<style>
.nav-btn {
  margin: 0 4px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: none;
  transition: color 0.3s ease;
}

.nav-btn:hover {
  color: var(--v-primary-base);
}

.navbar-brand {
  text-decoration: none;
  display: flex;
  align-items: center;
  font-weight: 700;
  letter-spacing: 1px;
}

.v-app-bar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
</style>
